export const state = () => ({
  isLoadingMaterials: false,
  activeCategoryId: '',
  activeSubCategoryId: '',
  categoryName: '',
  subCategoryName: '',
})

export const mutations = {
  toggleLoadingMaterials(state) {
    state.isLoadingMaterials = !state.isLoadingMaterials
  },
  categoryActiveId(state, id) {
    state.categoryActiveId = id
  },
  setCategoryName(state, categoryName) {
    state.categoryName = categoryName
  },
  setSubCategoryName(state, subCategoryName) {
    state.subCategoryName = subCategoryName
  },
  setActiveCategory(state, categoryId) {
    state.activeCategoryId = categoryId
  },
  setActiveSubCategory(state, subCategoryId) {
    state.activeSubCategoryId = subCategoryId
  },
}
